import React from 'react'
import { InputField, InputMaskField, TextAreaField, LabelField, Error } from './style'
import { Col } from '../grid/index'

const Label = ({ name, label }) => (
  <LabelField 
    htmlFor={`field_${name}`}>
      {label}:
  </LabelField>
)

const ErrorMessage = ({ children }) => (
  <Error>
    {children}
  </Error>
)

const InputFieldWithRef = (props) => {
  const { forwardRef } = props;
  return <InputField {...props} ref={forwardRef} />
}

const MaskedInput = props => {
  const { forwardRef, ...todoResto } = props;
  return <InputMaskField {...todoResto} inputRef={forwardRef} />
}

export const InputLabel = props => {
  const { 
    label, name, forwardRef, 
    required, errors, htmlType,
    span, responsive, mask
  } = props;

  const Field = props.mask ? MaskedInput : InputFieldWithRef

  return (
    <Col responsive={responsive} span={span}>
      <Label 
        label={label}
        name={name}
        />
      
      <Field
        id={`field_${name}`} 
        type={htmlType || 'text'}
        name={name} 
        required={required}
        forwardRef={forwardRef}
        mask={mask}
        />
      {errors[name] && (
        <ErrorMessage>
          {errors[name].message}
        </ErrorMessage>
      )}
    </Col>
  )
}

export const TextAreaLabel = props => {
  const { 
    label, name, forwardRef, 
    required, errors, htmlType,
    span, responsive
  } = props;

  return (
    <Col responsive={responsive} span={span}>
      <Label 
        label={label}
        name={name}
        />
      <TextAreaField 
        id={`field_${name}`} 
        type={htmlType || 'text'}
        name={name} 
        required={required}
        ref={forwardRef}
        />
      {errors[name] && (
        <ErrorMessage>{errors[name].message}</ErrorMessage>
      )}
    </Col>
  )
}